import type { Persistor } from 'redux-persist';

let persistor: Persistor | null = null;

export const setPersistor = (p: Persistor) => { persistor = p; };
export const getPersistor = () => persistor;



// WEBPACK FOOTER //
// ./src/persistor.ts